import React, {Component} from 'react'
import {observer} from 'mobx-react'

import TemplateHelper, {Wrapper as HelperWrapper} from 'lib/struct/TemplateHelper'

import UtmMarksForm from './UtmMarksForm'

import Hint from '../../struct/Hint'
import Field from '../../struct/Field'
import InputTextarea from '../../control/DependentInputTextarea'

import styles from './ExtraUrlParamsSettings.less'

const variables = [{
    variable: '{id}',
    description: 'id товара',
}, {
    variable: '{sku}',
    description: 'артикул товара',
}, {
    variable: '{name}',
    description: 'название товара',
}, {
    variable: '{contact_id}',
    description: 'id контакта, создавшего товар',
}, {
    variable: '{badge}',
    description: 'значок на товаре',
}, {
    variable: '{category_id}',
    description: 'id основной категории товара',
}, {
    variable: '{offer_id}',
    description: 'offer_id предложения',
}, {
    variable: '{f:название_характеристики}',
    description: 'значение характеристики товара',
},]

@observer export default class ExtraUrlParamsSettings extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const profile = context.profile

        return (
            <HelperWrapper>
                <Field label="UTM-метки">
                    <UtmMarksForm context={context}/>
                    <Hint>Ко всем адресам (URL), содержащимся в файле, будут автоматически добавлены UTM-метки, которые
                        позволят средствам веб-аналитики отслеживать переходы посетителей сайта по этим адресам. Если вы
                        не используете UTM-метки, просто оставьте поля пустыми.</Hint>
                </Field>

                <Field label="Дополнительные параметры в URL">
                    <InputTextarea
                        state={context.form_state}
                        value={profile.route_extra_url_params}
                        onChange={e => profile.route_extra_url_params = e.target.value}
                    />
                </Field>

                <TemplateHelper
                    variables={variables}
                    className={styles['template-helper-block']}
                />
            </HelperWrapper>
        )
    }
}